
import { City } from '../types/city-types';

// Mock cities data for Chiapas
export const chiapas_cities: City[] = [
  {
    city_id: 'TGZ',
    name: 'Tuxtla Gutiérrez',
    coordinates: [-93.1232, 16.7534], // Verified coordinates
    population: 604147,
    church_presence: 'Medium',
    region_id: 'CHIS',
    churches_count: 45,
    missionaries: 12,
    funding_amount: 78000,
    funding_percentage: 65,
    pledges: 42500,
    unreached_percentage: 65,
    image_url: 'https://upload.wikimedia.org/wikipedia/commons/c/c1/Centro_de_Tuxtla_Guti%C3%A9rrez%2C_Chiapas.jpg',
    description: 'Tuxtla Gutiérrez is the capital and largest city of the Mexican state of Chiapas. It has a strong evangelical presence but still has significant unreached populations, especially in the urban periphery.'
  },
  {
    city_id: 'SCC',
    name: 'San Cristóbal de las Casas',
    coordinates: [-92.6376, 16.7370], // Verified coordinates
    population: 215874,
    church_presence: 'Low',
    region_id: 'CHIS',
    churches_count: 18,
    missionaries: 9,
    funding_amount: 45000,
    funding_percentage: 38,
    pledges: 27800,
    unreached_percentage: 78,
    image_url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/San_Cristobal_de_las_Casas_%289481765179%29.jpg/1280px-San_Cristobal_de_las_Casas_%289481765179%29.jpg',
    description: 'San Cristóbal is a cultural hub with a strong indigenous presence. It faces challenges with traditional religious practices mixed with Christianity, creating a unique mission field.'
  },
  {
    city_id: 'TPL',
    name: 'Tapachula',
    coordinates: [-92.2620, 14.9018], // Verified coordinates
    population: 351165,
    church_presence: 'Low',
    region_id: 'CHIS',
    churches_count: 22,
    missionaries: 7,
    funding_amount: 58000,
    funding_percentage: 42,
    pledges: 31200,
    unreached_percentage: 72,
    image_url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b6/Catedral_de_Tapachula.jpg/1024px-Catedral_de_Tapachula.jpg',
    description: 'Tapachula is a border city with Guatemala, making it a strategic location for mission work with both local populations and migrants passing through.'
  },
  {
    city_id: 'CMT',
    name: 'Comitán',
    coordinates: [-92.1336, 16.2546], // Adjusted coordinates to be within Chiapas
    population: 141013,
    church_presence: 'Unreached',
    region_id: 'CHIS',
    churches_count: 8,
    missionaries: 3,
    funding_amount: 25000,
    funding_percentage: 21,
    pledges: 12500,
    unreached_percentage: 85,
    image_url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/45/Comit%C3%A1n_Chiapas.jpg/1024px-Comit%C3%A1n_Chiapas.jpg',
    description: 'Comitán is one of the larger cities in Chiapas with a significant unreached population, especially among indigenous communities.'
  },
  {
    city_id: 'OSG',
    name: 'Ocosingo',
    coordinates: [-92.0934, 16.9069], // Adjusted coordinates to be within Chiapas
    population: 45794,
    church_presence: 'Unreached',
    region_id: 'CHIS',
    churches_count: 4,
    missionaries: 2,
    funding_amount: 18000,
    funding_percentage: 15,
    pledges: 9500,
    unreached_percentage: 92,
    image_url: 'https://upload.wikimedia.org/wikipedia/commons/5/50/Ciudad_de_Ocosingo.jpg',
    description: 'Ocosingo is located in the eastern part of Chiapas and is a gateway to many rural indigenous communities that have limited access to the gospel.'
  }
];

// Get a city by ID from the Chiapas cities data
export const getCityById = (cityId: string): City | undefined => {
  return chiapas_cities.find(city => city.city_id === cityId);
};

// Get funding percentage for a city
export const getCityFundingPercentage = (city: City): number => {
  // If the city already has a funding_percentage, use that
  if (city.funding_percentage !== undefined) {
    return city.funding_percentage;
  }
  
  // Otherwise calculate a reasonable value based on church presence
  const basePercentage = {
    'High': 75,
    'Medium': 45,
    'Low': 25,
    'Unreached': 10
  }[city.church_presence] || 0;
  
  // Add some randomness to make it look more realistic
  return basePercentage + Math.floor(Math.random() * 15);
};
